var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors)?_c('div',_vm._l((_vm.errors[0]),function(error){return _c('div',{staticClass:"p-3 mb-2 bg-danger text-white"},[_c('p',[_c('strong',[_vm._v(_vm._s(error.title))])]),_c('p',[_vm._v(_vm._s(error.detail))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }